var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.37 22.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-C2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.69,3.57C1.37,6,2.08,9.76,1.82,10.23c-.07.14-1,.39-1.42,1.07A3.22,3.22,0,0,0,0,13.48c0,.87,0,7.19,0,7.45A2.58,2.58,0,0,0,1.1,22.42a3.19,3.19,0,0,0,2.13.35h10c1.43,0,3,.29,3.79-1.17.53-1,.29-3.57.29-4.75a43.78,43.78,0,0,0-.06-4.91,2.34,2.34,0,0,0-1.16-1.4c-.44-.23-.62-.07-.63-.65,0-1.83.18-3.95-.51-5.66A6.78,6.78,0,0,0,2.7,3.58Zm9.21,6.65H5.44a14.69,14.69,0,0,1-.06-2.51A5.11,5.11,0,0,1,5.66,5.5a3.26,3.26,0,0,1,6,0A5.32,5.32,0,0,1,12,7.79,13.83,13.83,0,0,1,11.9,10.22Zm-4.35,10,0-2.38c-.45-.43-.54-.35-.84-1a2.15,2.15,0,0,1,.68-2.56,2.21,2.21,0,0,1,1.3-.46A2.29,2.29,0,0,1,10,14.3a2.17,2.17,0,0,1-.2,3.52l0,2.38H7.55Z",
    transform: "translate(0 0)",
    fill: "gray",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2);
export default __webpack_public_path__ + "static/media/C2.1aa8b7910655cedce33f47e91b9bf9b6.svg";
export { ForwardRef as ReactComponent };